import type { TFunction } from 'i18next'

/** Názov druhu odmeny - vlastný bonus má meno (`type_label`), vstavaný typ
 *  sa prekladá podľa kľúča (`rewards.types.hourly-rate`…). */
export function rewardTypeLabel(
  t: TFunction,
  row: { type_name?: string | null; type_label?: string | null },
): string {
  if (row.type_label) return row.type_label
  return t(`rewards.types.${row.type_name}`, { defaultValue: row.type_name ?? '—' })
}
